import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Img from 'gatsby-image'
import { graphql } from 'gatsby'
import styled from 'styled-components'
import ReactPlayer from 'react-player'
import Media from 'react-media'

import { LineBreak } from '../components/StyledComponents'
import { media } from '../utils/media'
import { mediaQueries } from '../utils/tokens'

const Wrapper = styled.section`
  position: relative;
  min-height: 300px;
`
const BgImg = styled(Img)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: -1;

  height: ${props => props.mobileHeight || `100vh`};

  ${media.tablet`
    height: ${props => props.height || `85vh`};
  `}

  ${mediaQueries.xxxl} {
    height: 50vh;
  } 
  

  /* For iphone 5 users */
  @media (max-width: 321px) {
    height: 150vh;
  }

  & > img {
    object-fit: ${props => props.fit || 'cover'} !important;
    object-position: ${props => props.position || '50% 50%'} !important;
  }
  &::before {
    content: '';
    background-color: rgba(0,0,0,0.3);
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    z-index: 1;
  }
`

const Content = styled.div`
  transform: translate(-50%, -50%);
  position: absolute;
  min-width: 250px;
  width: 100%;
  max-width: 1440px;
  top: 50%;
  left: 50%;
  height: 100%;
  display: flex;
  padding: 0 2rem;
  z-index: 2;
`

const ContentContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: ${props => props.left ? `flex-start` : `center` };
  flex-direction: column;

  > * {
    ${props => props.left ? `
    text-align: left !important;
    margin-left: unset;
    ` : null }
  }

  ${media.tablet`
    width: 600px;
    
    ${props => props.left ? `margin-left: 4rem;` : `margin: 0 auto;`}
  `}
`

const Title = styled.h1`
  font-size: 2em;
  font-weight: 500;
  text-align: center;
  color: white;
  margin: 1rem 0 2rem;
  ${media.desktop`
    margin: 2rem 0 0;
    font-size: 3em;
  `}
`

const SubTitle = styled.p`
  font-weight: 400;
  font-size: 1rem;
  text-align: center;
  color: white;
  margin-bottom: 2rem;

  ${media.tablet`
    font-size: 1.2em;
  `}
`

const Overlay = styled.div`
  position: absolute;
  width: 100%;
  height: ${props => props.height || `inherit`};
  top: 0;
  left: 0;
  opacity: 0.36;
  background-image: linear-gradient(-180deg, #001839 69%, #F5A623 100%);
`

const VideoOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: radial-gradient(ellipse at center,rgba(0,0,0,.2) 0,rgba(0,0,0,.6) 100%);
  z-index: 1;
`

const TopLeftOverlay = styled.div`
  position: absolute;
  width: 100%;
  height: 80%;
  bottom: 0;
  left: 0;
  z-index: 0;
  /* Rectangle 20 Copy: */
  background-image: linear-gradient(
    -180deg,
    rgba(0, 0, 0, 0) 3%,
    rgb(0, 0, 0) 100%
  ) !important;
`

const TextOverlay = styled.div`
  color: ${ props => props.theme.colors.primaryBrand};
  position: absolute;
  right: 0;
  bottom: 100px;
  z-index: 1000 !important;
`

const TextOverlayContent = styled.p`
  background-color: ${ props => props.theme.colors.white};
  font-size: 1.5rem;
  font-weight: 600;
  font-style: italic;
  padding: 0.5rem 2rem;
  margin-bottom: 8px;
  z-index: 9999 !important;
`

const VideoPlayer =styled(ReactPlayer)`
  video {
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    min-height: 100vh;
    object-fit: cover;
    object-position: center;
  }
`

const parseImageDescription = (description) => {
  return description.split(';')
}

const removeSpaces = (listOfStrings) => {
  const cleanList = listOfStrings.map((string) => {
    return string.trim()
  })

  return cleanList
}

class Hero extends Component {
  constructor(props) {
    super(props)
    this.state = { key: 0 }
  }

  componentDidMount() {
    this.setState({ key: 1 })
  }

  overlay() {
    const { props } = this
    if (props.overlay === "leftCornerTop") {
      return <TopLeftOverlay {...props.height}/>
    } else if(props.overlay === "none") {
      return null
    } else {
      return <Overlay {...props.height} />
    }
  }

  showTextOverlay(image) {
    if(image.description) {
      const imageDescriptionList =
        removeSpaces(parseImageDescription(image.description))

      return (
        <TextOverlay>
            <div>
              {imageDescriptionList.map((description, index) => {
                return (
                  <TextOverlayContent
                    key={index}
                  >
                    {description}
                  </TextOverlayContent>
                )
              })}
            </div>
        </TextOverlay>
      )
    }

    return null;
  }

  showContent() {
    const { props } = this
    
    // terminate early if user provides content prop
    if(props.content) { return props.content }

    return (
      <Content
        left={props.contentLeft}
      >
        <ContentContainer
          left={props.contentLeft}
        >
          <Title>{props.hero.title}</Title>
          <LineBreak />
          <SubTitle>{props.hero.subtitle && props.hero.subtitle.internal.content}</SubTitle>
          {props.callToAction}
        </ContentContainer>
      </Content>
    )
  }

  showDefaultBackground(image) {
    return (
      <BgImg
        height={this.props.height}
        mobileHeight={this.props.mobileHeight}
        fluid={image.fluid}
        alt={image.title}
        {...this.props}
      />
    )
  }

  showActiveBackground() {
    const {
      activeBackground,
      backgroundPhoto,
      backgroundVideo,
    } = this.props.hero

    switch (activeBackground) {
      case 'video':
        return (
          <>
            <VideoOverlay />
            <VideoPlayer
              url={backgroundVideo}
              muted
              playing
              loop
              height="100vh"
              width="100%"
            />
            {this.overlay()}
          </>
        )
      case 'svg':
        return (
          this.props.background
        )
      default:
        return (
          <div>
            {backgroundPhoto && this.showDefaultBackground(backgroundPhoto)}
            {this.overlay()}
          </div>
        )
    }
  }
  
  render() {
    const { hero } = this.props
    return (
      <Wrapper>
        <Media query="(max-width: 550px)" key={this.state.key}>
        {matches =>
          matches ? (
           hero.activeBackground !== 'svg' ?
            <BgImg
              height={this.props.height}
              mobileHeight={this.props.mobileHeight}
              fluid={this.props.hero.backgroundPhoto.fluid}
              backgroundColor={'#eeeeee'}
              alt={this.props.hero.backgroundPhoto.title}
              style={{
                maxWidth: this.props.hero.backgroundPhoto.fluid.presentationWidth,
                margin: "0 auto",
              }}
            /> : this.showActiveBackground()
          ) : (
            <React.Fragment>
              {hero && this.showActiveBackground()}
            </React.Fragment>
          )
        }
        </Media>
        {hero && this.showContent()}
      </Wrapper>
    )
  }
}

Hero.propTypes = {
  hero: PropTypes.shape({
    backgroundPhoto: PropTypes.shape({
      fluid: PropTypes.object.isRequired,
    }),
    activeBackground: PropTypes.string,
    backgroundVideo: PropTypes.string,
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.shape({
      internal: PropTypes.shape({
        content: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  }),
  content: PropTypes.node,
  background: PropTypes.node,
  callToAction: PropTypes.element,
  mobileHeight: PropTypes.string,
  backgroundColor: PropTypes.string,
  contentLeft: PropTypes.bool,
  overlay: PropTypes.string,
}

Hero.defaultProps = {
  title: null,
  subTitle: null,
  callToAction: null,
  background: null,
  content: null,
}

export const heroFragment = graphql`
  fragment HeroFragment on ContentfulHero {
    title
    tagline {
      childMarkdownRemark {
        html
      }
    }
    callToActionText
    callToActionUrl
    callToActionTextSecondary
    callToActionUrlSecondary
    type
    activeBackground
    backgroundPhoto {
      title
      description
      file {
        url
      }
      mobileFluid: fluid(maxWidth: 400) {
            ...GatsbyContentfulFluid_withWebp
          } 
      fluid(quality: 100, maxWidth: 3000) {
        ...GatsbyContentfulFluid_withWebp
      }
    }
    backgroundVideo
  }
`

export const heroFragmentWithCarousel = graphql`
  fragment HeroFragment_withCarousel on ContentfulHero {
    ...HeroFragment
        backgroundCarousel {
      title
      media {
        fluid(quality: 90) {
          ...GatsbyContentfulFluid_withWebp
        }
      }
    }
  }
`

export default Hero
